import { Device } from '../types';

export type OtaMode = 'none' | 'opt-in' | 'force';
export type NewDeviceOtaMode = 'off' | 'opt-in' | 'force';

export const OTA_MODE_OPTIONS: { value: OtaMode; label: string }[] = [
  { value: 'none', label: 'None' },
  { value: 'opt-in', label: 'Opt-in' },
  { value: 'force', label: 'Force' },
];

export const NEW_DEVICE_OTA_OPTIONS: { value: NewDeviceOtaMode; label: string }[] = [
  { value: 'off', label: 'Off' },
  { value: 'opt-in', label: 'Opt-in' },
  { value: 'force', label: 'Force' },
];

export function normalizeNewDeviceOtaSetting(raw: unknown): NewDeviceOtaMode {
  if (raw === true) return 'opt-in';
  if (raw === 'force' || raw === 'opt-in' || raw === 'off') return raw;
  return 'off';
}

export function resolveOtaMode(deployment?: Device['deployment'] | null): OtaMode {
  if (deployment?.otaMode === 'none' || deployment?.otaMode === 'opt-in' || deployment?.otaMode === 'force') {
    return deployment.otaMode;
  }
  if (deployment?.otaEligible && deployment?.otaForceUpdate) return 'force';
  if (deployment?.otaEligible) return 'opt-in';
  if (deployment?.otaForceUpdate) return 'force';
  return 'none';
}

export function otaModeLabel(mode: OtaMode): string {
  if (mode === 'opt-in') return 'Opt-in';
  if (mode === 'force') return 'Force';
  return 'None';
}

const OTA_MODE_COLORS: Record<OtaMode, { backgroundColor: string; color: string; borderColor: string }> = {
  none: { backgroundColor: '#e9ecef', color: '#495057', borderColor: '#ced4da' },
  'opt-in': { backgroundColor: '#cfe2ff', color: '#084298', borderColor: '#9ec5fe' },
  force: { backgroundColor: '#e0cffc', color: '#3d0a91', borderColor: '#c5a8f5' },
};

export function otaModeColorStyle(mode: OtaMode): { backgroundColor: string; color: string; borderColor: string } {
  return OTA_MODE_COLORS[mode] || OTA_MODE_COLORS.none;
}

export const OTA_MODE_CHART_COLORS: Record<OtaMode, string> = {
  none: OTA_MODE_COLORS.none.backgroundColor,
  'opt-in': OTA_MODE_COLORS['opt-in'].backgroundColor,
  force: OTA_MODE_COLORS.force.backgroundColor,
};

export function fieldsForOtaMode(mode: OtaMode): Pick<Device['deployment'], 'otaMode' | 'otaEligible' | 'otaForceUpdate'> {
  if (mode === 'force') {
    return { otaMode: 'force', otaEligible: true, otaForceUpdate: true };
  }
  if (mode === 'opt-in') {
    return { otaMode: 'opt-in', otaEligible: true, otaForceUpdate: false };
  }
  return { otaMode: 'none', otaEligible: false, otaForceUpdate: false };
}
